const cards = [
  {
    id: "coding",
    title: "Coding",
    img: "/assets/Card/code.png",
    alt: "Coding art",
    description: "Code projects and tools",
    link: "/coding",
    group: "main",
  },
  {
    id: "art",
    title: "Art",
    img: "/assets/Card/sky.png",
    alt: "Art portfolio",
    description: "My drawings and paintings",
    link: "/art",
    group: "main",
  },
  {
    id: "other",
    title: "Other",
    img: "/assets/Collage/1.png",
    alt: "Other stuff",
    description: "Misc creativity",
    link: "/other",
    group: "main",
  },
];

export default cards;